import { BASVURU_ISIM_DEGISIKLIK_KONU_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const basvuruIsimDegisiklikKonuSorgula = (parentObjectId) => {
    return getRequest({ url: BASVURU_ISIM_DEGISIKLIK_KONU_SORGULA + "?parentObjectId=" + parentObjectId });
}

export default basvuruIsimDegisiklikKonuSorgula;